import { format, parseISO } from "date-fns";
import { formatDate } from "../../../utils/formatDate";
import { useAppContext } from "../../../context/AppContext";

export const TableContractstoReadjust = ({ table }) => {
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const monthNames = [
    { number: 1, name: "Janeiro" },
    { number: 2, name: "Fevereiro" },
    { number: 3, name: "Março" },
    { number: 4, name: "Abril" },
    { number: 5, name: "Maio" },
    { number: 6, name: "Junho" },
    { number: 7, name: "Julho" },
    { number: 8, name: "Agosto" },
    { number: 9, name: "Setembro" },
    { number: 10, name: "Outubro" },
    { number: 11, name: "Novembro" },
    { number: 12, name: "Dezembro" },
  ];

  const columns = [
    "Número",
    "Cliente",
    "Data Venda",
    nomenclature[0].label,
    nomenclature[1].label,
    "Último Reajuste",
    "Índice",
  ];

  const formatData = (str) => {
    const string = str.split(" ");
    const dataObj = parseISO(string[0]);
    const dataFormatada = format(dataObj, "dd/MM/yyyy");
    return dataFormatada;
  };
  return (
    <>
      <table style={{ width: "100%" }} className="my-3">
        <tbody>
          {Object.keys(table.data)
            .sort((a, b) => parseInt(a) - parseInt(b)) // Ordena os meses numericamente
            .map((months, i) => {
              const month = table.data[months];
              return (
                month && (
                  <>
                    <tr
                      className="text-center fw-bolder"
                      style={{
                        backgroundColor: "#636363",
                        color: "#ffffff",
                      }}
                    >
                      <td colSpan={7} className="py-2">
                        Ajuste em{" "}
                        {monthNames.find((item) => item.number === parseInt(months))?.name}
                      </td>
                    </tr>
                    <tr
                      className="fw-bolder"
                      style={{
                        backgroundColor: "#b8b8b8",
                        color: "#2D2D2D",
                      }}
                    >
                      {columns.map((item, i) => (
                        <td
                          key={i}
                          className="border border-white border-1 p-1 text-center"
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "9px",
                          }}
                        >
                          {item}
                        </td>
                      ))}
                    </tr>
                    {month.data.map((contract, i) => (
                      <tr
                        key={contract.id}
                        style={
                          contract?.status === 0
                            ? { backgroundColor: "#F2E932", color: "#000000" }
                            : {}
                        }
                      >
                        <td className="border p-1">{contract.id}</td>
                        <td className="border p-1">{contract.client}</td>
                        <td className="border p-1">
                          {format(new Date(contract.created_at), "dd/MM/yyyy")}
                        </td>
                        <td className="border p-1">{contract.block}</td>
                        <td className="border p-1">{contract.land}</td>
                        <td className="border p-1">
                          {contract.date_reajust
                            ? contract.date_reajust.includes("T")
                              ? formatDate(contract.date_reajust)
                              : formatData(contract.date_reajust)
                            : ""}
                        </td>
                        <td className="border p-1">
                          {contract.index_reajusted?.name ?? ""}
                        </td>
                      </tr>
                    ))}
                  </>
                )
              );
            })}
        </tbody>
      </table>
      <div className="d-flex">
        <h5 className="ps-2">Total de Registros: {table.count}</h5>
      </div>
    </>
  );
};
